import { AssistantResponseTokenV2 } from 'generated/graphql';
import { useCallback } from 'react';
import {
  constructMarkdownFromAssistantResponseToken,
  convertMarkdownToHTML,
  getMarkdownForClipboardFromAssistantResponse,
} from '../utils';
import { useGetQuantifyLink } from './useGetQuantifyLink';

interface UseCopyAssistantResponseMarkdownAsHTMLParams {
  assistantResponseTokenV2List: AssistantResponseTokenV2[] | undefined;
}

export const useCopyAssistantResponseMarkdownAsHTML = ({
  assistantResponseTokenV2List,
}: UseCopyAssistantResponseMarkdownAsHTMLParams) => {
  const { getQuantifyLink, isLoading } = useGetQuantifyLink();

  const markdownToCopy = useCallback(async () => {
    const markdown = constructMarkdownFromAssistantResponseToken({
      assistantResponseTokenV2List,
      tokenToMarkdownConverter: (token: AssistantResponseTokenV2) =>
        getMarkdownForClipboardFromAssistantResponse(token, getQuantifyLink),
    });

    const html = convertMarkdownToHTML(markdown);
    const markdownWithoutLinks = markdown.replace(
      /\[.*?\]\(.*?\), |\[.*?\]\(.*?\)/g,
      '',
    );

    if ('ClipboardItem' in window) {
      const item = new window.ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([markdownWithoutLinks], {
          type: 'text/plain',
        }),
      });
      await navigator.clipboard.write([item]);
    } else {
      await navigator.clipboard.writeText(markdownWithoutLinks);
    }

    return markdown;
  }, [assistantResponseTokenV2List, getQuantifyLink]);

  return {
    markdownToCopy,
    isLoading,
  };
};
